module.exports = __webpack_public_path__ + "img/Mask Group 23.6ef941d1.svg";